import { render } from "./MailModal.vue?vue&type=template&id=2a775f7a"
import script from "./MailModal.vue?vue&type=script&lang=js"
export * from "./MailModal.vue?vue&type=script&lang=js"
script.render = render

export default script